import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "./AuthContext";

export const DataContext = createContext({});

const Provider = DataContext.Provider;

const PER_PAGE = 100;

export const fetchAll = async (getAllFunc, ...args) => {
  let res = [];
  let page = 0;

  while (true) {
    try {
      const { statusText, data } = await getAllFunc(PER_PAGE, page, ...args);

      if (statusText !== "OK") break;

      if (!Array.isArray(data) || data.length === 0) break;

      res = res.concat(data);

      if (data.length < PER_PAGE) break;

      page = page + 1;
    } catch (e) {
      break;
    }
  };

  return res;
};

export const DataProvider = ({children}) => {
  const [piece, setPiece] = useState(null);
  const [issues, setIssues] = useState(null);
  const [issueIds, setIssueIds] = useState(null);
  const [currentIssueIndex, setCurrentIssueIndex] = useState(null);
  const [authors, setAuthors] = useState(null);
  const [books, setBooks] = useState(null);
  const [about, setAbout] = useState(null);
  const [menuPages, setMenuPages] = useState(null);
  const areIssuesLoaded = useRef(false);
  const [contacts, setContacts] = useState(null);
  const { api } = useContext(AuthContext);

  const getIssue = useCallback(async (issueId) => {
    try {
      const response = await api.getIssueWithPieces(issueId);
      const issue = response.data.issue;
      setIssues({
        ...issues,
        [issue.id]: issue,
      });
    } catch (error) {
    };
  }, [api, issues]);

  const getPages = useCallback(async () => {
    try {
      const response = await api.getMenuPages();
      const pages = response.data;
      setMenuPages(pages);
    } catch (error) {
    };
  }, [api]);

  const getContacts = useCallback(async () => {
    try {
      const response = await api.getContacts();
      const contacts = response.data.filter(c => c.status !== 'not_published')
      contacts.sort((a, b) => a.display_order - b.display_order);
      setContacts(contacts);
    } catch (error) {
    };
  }, [api]);

  useEffect(() => {
    getPages();
    getContacts();
  }, [api, getPages, getContacts]);

  return (
    <Provider value={{
      piece, setPiece,
      issues, setIssues,
      issueIds, setIssueIds,
      currentIssueIndex, setCurrentIssueIndex,
      getIssue,
      authors, setAuthors,
      books, setBooks,
      about, setAbout,
      menuPages, setMenuPages,
      contacts, setContacts,
      areIssuesLoaded,
    }}>
      {menuPages && children}
      {/* {children} */}
    </Provider>
  )
};